const getInitialProductsFromCollection = (categoryHandle) => {
    return `{
        collection(handle: "${categoryHandle}") {
            handle
            products(first: 24)
            {
                edges {
                    node {
                        id
                        title
                        handle
                        availableForSale
                        descriptionHtml
                        totalInventory
                        priceRange {
                            maxVariantPrice {
                                amount
                            }
                            minVariantPrice {
                                amount
                            }
                        }
                        compareAtPriceRange {
                            maxVariantPrice {
                                amount
                            }
                            minVariantPrice {
                                amount
                            }
                        }
                        featuredImage {
                            altText
                            url
                        }
                        images(first: 200) {
                            edges {
                                node {
                                    url
                                }
                            }
                        }
                        variants(first: 2) {
                            nodes {
                                id
                                quantityAvailable
                                priceV2 {
                                    amount
                                }
                            }
                        }
                        collections(first: 50) {
                            edges {
                                node {
                                    title
                                }
                            }
                        }
                        tags
                        productWarningValue: metafield(
                            namespace: "custom"
                            key: "product_warning"
                        ) {
                            value
                        }
                    }
                    cursor
                }
                pageInfo {
                    hasNextPage
                }
            }
        }
    }`
}

export default getInitialProductsFromCollection
